import React, {useState} from 'react';
import ReactQuill from "react-quill";
import {useSnackbar} from "notistack";
import {useForm} from "react-hook-form";
import {useDispatch, useSelector} from "react-redux";
import {CustomDialog, MembersAvatar} from "components";
//Material UI Components
import {
    Button,
    Chip,
    DialogActions,
    DialogContent,
    Grid,
    IconButton,
    makeStyles,
    TextField,
    Typography,
    useMediaQuery,
    useTheme,
} from "@material-ui/core";
import {useSendMessage} from "hooks";
import FileManager from "./fileManager";
import Alert from "@material-ui/lab/Alert";
import SendIcon from "@material-ui/icons/Send";
import CloseIcon from '@material-ui/icons/Close';
import AttachFileIcon from "@material-ui/icons/AttachFile";
import {setFileManagerDialog, setMemberDialog, setNewMessageDialog, unsetAttachedFiles} from "redux/actions";

const useStyles = makeStyles(theme => ({
    messageContainer: {
        overflow: 'hidden'
    },
    reactQuill: {
        height: "30vh",
        width: '100%',

    },
    dialogContent: {
        padding: 0,
        [theme.breakpoints.down('sm')]: {
            height: '80vh'
        }
    },
    dialogPadding: {
        marginLeft: '1em',
    }

}));

const NewMessageDialog = ({open, memberRecords, setMemberRecords}) => {
    const theme = useTheme();
    const classes = useStyles();
    const dispatch = useDispatch();
    const {enqueueSnackbar} = useSnackbar();
    const {register, handleSubmit, errors, reset} = useForm();
    const matchesSM = useMediaQuery(theme.breakpoints.down('sm'));

    const handleReset = () => {
        setMemberRecords([]);
        setMessage('');
        reset();
    };
    const clearMember = () => setMemberRecords([]);
    const openFileManager = () =>dispatch(setFileManagerDialog(true));
    const closeFileManager = () => dispatch(setFileManagerDialog(false));

    const [message, setMessage] = useState('');

    const {fileManagerDialog} = useSelector(state => state?.inbox)
    const {attachedFiles} = useSelector(state => state?.fileManager)

    const [sendMessage] = useSendMessage(handleReset)

    const onSubmit = async (data) => {
        if (!memberRecords.length) return enqueueSnackbar("Please Select Member", {variant: "warning"});
        else if (!message.length) return enqueueSnackbar("Message field can not be empty", {variant: "warning"});

        data.message = message;
        data.to = memberRecords;
        data.attachedFile = attachedFiles;

        enqueueSnackbar("Message Sending", {variant: "info"});
        dispatch(setNewMessageDialog(false));
        await sendMessage(data);
    }

    return (
        <CustomDialog handleClose={() => dispatch(setNewMessageDialog(false))}
                      fullWidth={true}
                      dialogStatus={open}
                      title='New Message'
                      maxWidth='lg'
                      fullScreen={matchesSM}
        >
            <form onSubmit={handleSubmit(onSubmit)}>
                <DialogContent className={classes.dialogContent}>
                    <Grid container>
                        <Grid item container justify="space-between" alignItems={'center'}>
                            <Grid item className={classes.dialogPadding}
                                  onClick={() => dispatch(setMemberDialog(true))}>
                                <Typography>TO</Typography>
                                <MembersAvatar memberRecords={memberRecords}/>
                            </Grid>
                            {memberRecords?.length > 0 &&
                            <Grid item>
                                <IconButton onClick={clearMember}>
                                    <CloseIcon/>
                                </IconButton>
                            </Grid>
                            }
                        </Grid>
                        <Grid item container className={classes.dialogPadding}>
                            <TextField variant={"standard"} name="subject" margin="dense" id="subject" label="Subject"
                                       inputRef={register({required: true})} fullWidth/>

                            {errors.subject && <Alert severity="error">Please Fill This Field</Alert>}
                        </Grid>
                        <Grid item container className={classes.messageContainer}>
                            <ReactQuill className={classes.reactQuill} value={message} name="message"
                                        onChange={(value) => setMessage(value)}/>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Grid container alignItems='center' justify="space-between">
                        <Grid item xs container>
                            {
                                attachedFiles?.length > 0
                                    ? <Chip label={`${attachedFiles.map(file => `${file.name}`)} is attached`}
                                            variant="outlined" color="primary" size="small"
                                            onDelete={() => dispatch(unsetAttachedFiles())}/>
                                    : null
                            }
                        </Grid>
                        <Grid item>
                            <IconButton onClick={openFileManager} aria-label="delete" component="label">
                                <AttachFileIcon/>
                            </IconButton>
                            <Button type="submit" variant="outlined" color="primary" size="medium" endIcon={<SendIcon/>}>
                                Send
                            </Button>
                        </Grid>
                    </Grid>
                </DialogActions>
            </form>
            <CustomDialog dialogStatus={fileManagerDialog}
                          title={'FileManager'}
                          handleClose={closeFileManager}
                          maxWidth='lg'
                          fullScreen={true}>
                <DialogContent>
                    <FileManager/>
                </DialogContent>
            </CustomDialog>
        </CustomDialog>
    )
};

export default NewMessageDialog;
